import styles from './Patterns.module.css'

export function SummaryStrip({ items = [], label = 'Summary', className = '' }) {
  return (
    <section className={`${styles.summary} ${className}`.trim()} aria-label={label} style={{ '--wf-summary-count': items.length }}>
      {items.map((item) => <div key={item.key || item.label} className={styles.summaryItem} aria-label={item.description || `${item.label}: ${item.value}`}><span className={styles.summaryLabel}>{item.label}</span><strong className={styles.summaryValue}>{item.value}</strong>{item.comparison ? <span className={styles.summaryComparison}>{item.comparison}</span> : null}</div>)}
    </section>
  )
}
